import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme deve ser usado dentro de um ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    // Estado do tema - 'rf' (design atual) ou 'rf-test' (design novo)
    const [currentTheme, setCurrentTheme] = useState('rf');
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    // Carregar tema salvo do localStorage
    useEffect(() => {
        const savedTheme = localStorage.getItem('genia-theme');
        const savedSidebarState = localStorage.getItem('genia-sidebar-collapsed');
        
        if (savedTheme && (savedTheme === 'rf' || savedTheme === 'rf-test')) {
            setCurrentTheme(savedTheme);
            // Aplicar tema ao body
            document.body.setAttribute('data-theme', savedTheme);
        } else {
            // Tema padrão
            document.body.setAttribute('data-theme', 'rf');
        }
        
        if (savedSidebarState) {
            setSidebarCollapsed(JSON.parse(savedSidebarState));
        }
    }, []);

    // Aplicar tema ao body quando mudar
    useEffect(() => {
        document.body.setAttribute('data-theme', currentTheme);
    }, [currentTheme]);

    // Salvar tema no localStorage quando mudar
    const toggleTheme = () => {
        const newTheme = currentTheme === 'rf' ? 'rf-test' : 'rf';
        setCurrentTheme(newTheme);
        localStorage.setItem('genia-theme', newTheme);
    };

    // Gerenciar estado do sidebar (apenas para tema rf-test)
    const toggleSidebar = () => {
        const newState = !sidebarCollapsed;
        setSidebarCollapsed(newState);
        localStorage.setItem('genia-sidebar-collapsed', JSON.stringify(newState));
    };

    const value = {
        currentTheme,
        toggleTheme,
        isRfTest: currentTheme === 'rf-test',
        isRf: currentTheme === 'rf',
        sidebarCollapsed,
        setSidebarCollapsed,
        toggleSidebar
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};